import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Bg20140612 from 'assets/img/cps/bg2.png'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'

import { animated, useSprings, useTrail } from '@react-spring/web'
import { useNavigate } from 'react-router-dom'

import ImgTennis from 'assets/img/cps/cps_tennis.png'
import ImgIndoor from 'assets/img/cps/cps_indoor.png'
import ImgBasketball from 'assets/img/cps/cps_basketball.png'
import ImgSoccer from 'assets/img/cps/cps_soccer.png'
import ImgEtc from 'assets/img/cps/cps_etc.png'

import TcImg from 'assets/img/screenType2/tc.png'

const Container = styled.div`
	position: relative;
	width: 1920px;
	height: 1080px;
	padding-top: 287px;
	padding-left: 94px;
	padding-right: 94px;
	background-image: url(${Bg20140612});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
`

const IconContainer = styled.div`
	position: absolute;
	right: 157px;
	top: 50%;
	transform: translateY(-50%);
	list-style: none;
	padding: 0;
	margin: 0;
	display: block;
	.row {
		display: flex;
		justify-content: center;
	}
	button {
		border: 0;
		outline: 0;
		background: transparent;
		img {
			max-width: 100%;
			padding: 0 10px;
		}
	}
`

/**
 * SPS 화면
 * @param param0
 * @returns
 */
const ScreenType2 = ({ menuList, oldMenuList }: any) => {
	const navigate = useNavigate()
	const deviceInfo = useSelector(selectDevice)

	const [trail, api] = useTrail(menuList.length, () => ({
		rotateX: 0,
	}))

	const [rand, setRand] = useState<number>(0)

	const isFlipped = useRef(false)

	const blockWhileDragging = (isDragging: any) => {
		let slides = document.getElementsByClassName('slick-slide')

		if (isDragging) {
			for (let i = 0; i < slides.length; i++) {
				slides[i].classList.add('is-dragging') // is-dragging 클래스 추가
			}
		} else {
			for (let i = 0; i < slides.length; i++) {
				slides[i].classList.remove('is-dragging') // is-dragging 클래스 제거
			}
		}
	}

	const [isDragging, setIsDragging] = useState(false)

	const handleTouchStart = () => {
		setIsDragging(false)
	}

	const handleTouchMove = () => {
		setIsDragging(true)
	}

	const handleTouchEnd = (index: number) => {
		if (!isDragging) {
			pageMove(menuList[index])
		}
		setIsDragging(false)
	}

	const pageMove = (e: any) => {
		console.log(e)
		console.log(oldMenuList)
		if (e.title === '테니스') {
			e.engTitle = 'TENNIS'
		} else if (e.title === '인도어 스포츠') {
			e.engTitle = 'INDOOR'
		} else if (e.title === '농구') {
			e.engTitle = 'BASKETBALL'
		} else if (e.title === '축구') {
			e.engTitle = 'SOCCER'
		} else if (e.title === '그 외 종목') {
			e.engTitle = 'ETC'
		}
		if (e.title === '테니스') {
			const old = oldMenuList[0]
			old.subsortId = 6
			old.fileId = 1205
			navigate('/cps/tennis', { state: { item: e } })
		} else {
			navigate('/cps/list', { state: { item: e } })
		}
	}

	useEffect(() => {
		console.log('=================================')
		console.log(menuList)
		console.log(oldMenuList)
		console.log('================================')
		if (deviceInfo.branchCd && deviceInfo.kioskName) {
			setTimeout(() => {
				if (isFlipped.current) {
					api.start({
						rotateX: 0,
					})
					isFlipped.current = false
				} else {
					api.start({
						rotateX: 360,
					})
					isFlipped.current = true
				}
				// setRand(Math.random())
			}, 5000)
		}
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
		// const path = document.querySelector('.hexagon') as SVGPathElement
		// const length = path.getTotalLength()
		// console.log(length)
	}, [rand])

	// 에니메이션 텍스트
	// const text = 'Touch the screen'.split('')

	// 각 글자마다 애니메이션 상태 생성
	// const [springs] = useSprings(text.length, (i) => ({
	// 	from: { opacity: 0 },
	// 	to: { opacity: 1 },
	// 	loop: { reverse: true },
	// }))

	return (
		<Container>
			{/* <TochTheScreen>
				<div
					style={{
						display: 'flex',
						fontSize: '32px',
						fontWeight: 'lighter',
						color: '#001f66',
						fontFamily: 'asics regular',
					}}
				>
					{springs.map((style, i) => (
						<animated.span
							key={i}
							style={{
								...style,
								marginRight: 2,
								display: 'inline-block',
							}}
						>
							{text[i] === ' ' ? '\u00A0' : text[i]}
						</animated.span>
					))}
				</div>
			</TochTheScreen> */}
			<img
				src={TcImg}
				alt="터치"
				style={{
					display: 'block',
					width: '450px',
					position: 'absolute',
					top: '680px',
					left: '110px',
				}}
			/>
			<IconContainer>
				<div className="row">
					{/* cpsMenuList 3개만 출력 */}
					{menuList.slice(0, 3).map((item: any, index: number) => (
						<button
							key={index}
							type="button"
							onTouchStart={handleTouchStart}
							onTouchMove={handleTouchMove}
							onTouchEnd={() => handleTouchEnd(index)}
							onMouseDown={handleTouchStart}
							onMouseMove={handleTouchMove}
							onMouseUp={() => handleTouchEnd(index)}
						>
							<img
								src={index === 0 ? ImgTennis : index === 1 ? ImgIndoor : ImgBasketball}
								alt={item.title}
							/>
						</button>
					))}
				</div>
				<div className="row">
					{menuList.slice(3, 5).map((item: any, index: number) => (
						<button
							key={index}
							type="button"
							onTouchStart={handleTouchStart}
							onTouchMove={handleTouchMove}
							onTouchEnd={() => handleTouchEnd(index + 3)}
							onMouseDown={handleTouchStart}
							onMouseMove={handleTouchMove}
							onMouseUp={() => handleTouchEnd(index + 3)}
						>
							<img
								src={index === 0 ? ImgSoccer : ImgEtc}
								alt={item.title}
							/>
						</button>
					))}
				</div>
				{/* <div className="slideWrapper">
					<div>
						<button
							className="item"
							type="button"
							// onClick={() => pageMove(menuList[index])}
							onTouchStart={handleTouchStart}
							onTouchMove={handleTouchMove}
							onTouchEnd={() => handleTouchEnd(0)}
							onMouseDown={handleTouchStart}
							onMouseMove={handleTouchMove}
							onMouseUp={() => handleTouchEnd(0)}
							style={{ position: 'relative' }}
						>
							<img
								src={MnTennis}
								alt="tennis"
								loading="lazy"
							/>
							<span
								style={{
									position: 'absolute',
									bottom: '64px',
									left: 0,
									right: 0,
									textAlign: 'center',
									fontSize: '50px',
									color: '#494949',
									fontFamily: 'asics regular',
								}}
							>
								<p
									className="ascis-regular"
									style={{ marginBottom: '15px' }}
								>
									TENNIS
								</p>
								<p
									className=""
									style={{
										fontSize: '30px',
										fontFamily: 'asics regular',
									}}
								>
									테니스
								</p>
							</span>
						</button>
						<button
							className="item"
							type="button"
							// onClick={() => pageMove(menuList[index])}
							onTouchStart={handleTouchStart}
							onTouchMove={handleTouchMove}
							onTouchEnd={() => handleTouchEnd(1)}
							onMouseDown={handleTouchStart}
							onMouseMove={handleTouchMove}
							onMouseUp={() => handleTouchEnd(1)}
							style={{ position: 'relative' }}
						>
							<img
								src={MnVolleyball}
								alt="indoor volleyball"
								loading="lazy"
							/>
							<span
								style={{
									position: 'absolute',
									bottom: '64px',
									left: 0,
									right: 0,
									textAlign: 'center',
									fontSize: '50px',
									color: '#494949',
									fontFamily: 'asics regular',
								}}
							>
								<p
									className="ascis-regular"
									style={{
										marginBottom: '0px',
										fontFamily: 'asics regular',
									}}
								>
									INDOOR
								</p>
								<p
									className="ascis-regular"
									style={{
										marginBottom: '7px',
										fontSize: '25px',
										fontFamily: 'asics regular',
									}}
								>
									VOLLEYBALL
								</p>
								<p
									className=""
									style={{
										fontSize: '30px',
										fontFamily: 'asics regular',
									}}
								>
									인도어
								</p>
							</span>
						</button>
					</div>
				</div> */}
			</IconContainer>
		</Container>
	)
}

export default ScreenType2
